import { getCookieWithoutJSON } from './cookies'

export const localStorageWorkspaceId = 'workspaceId'

export const refreshWorkspaceId = 'refreshWorkspaceId'

export function getWorkspaceIdFromLocalStorage(): string | null | undefined {
  return getCookieWithoutJSON('workspaceId')
}
